import { render, staticRenderFns } from "./new_user_gift.vue?vue&type=template&id=802263b8&scoped=true"
import script from "./new_user_gift.vue?vue&type=script&lang=js"
export * from "./new_user_gift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802263b8",
  null
  
)

export default component.exports